import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import WcbCallCodeSelect from './WcbCallCodeSelect';
import { getTranslation } from '../../constants/languages';

type WcbCallContainerProps = {
    iimclient: ConfigClientType;
    wcbCallCodes: Array<string>;
    mobile?: string;
    mobileError?: MobileErrorType;
    changeSelectedCallCode: Function;
    changeMobile: Function;
};

const MobileIsEmptyError = {
    lang_fi: 'Anna puhelinnumero',
    lang_se: null,
    lang_dk: null,
    lang_no: null,
    lang_en: null,
};

const InvalidMobileError = {
    lang_fi: 'Virheellinen puhelinnumero',
    lang_se: null,
    lang_dk: null,
    lang_no: null,
    lang_en: null,
};

export enum MobileErrorType {
    Empty,
    Invalid,
}

const WcbCallContainer = ({
    iimclient,
    wcbCallCodes,
    mobile,
    mobileError,
    changeSelectedCallCode,
    changeMobile,
}: WcbCallContainerProps) => {
    const { segment, lang } = iimclient;

    const handleChange = ({ target }) => changeMobile(target.value);
    const phoneLabel = segment.labelphone || 'phone';

    const mobileErrorMessage: string = (() => {
        if (mobileError === MobileErrorType.Empty) return getTranslation(lang, MobileIsEmptyError);
        if (mobileError === MobileErrorType.Invalid)
            return getTranslation(lang, InvalidMobileError);

        return '';
    })();

    return (
        <div className="input-block" id="wcb-phone-container">
            <label htmlFor="wcb-phone" id="wcb-labelphone">
                {phoneLabel}
            </label>
            <div className="wrapper">
                <div className="select-input">
                    <WcbCallCodeSelect
                        wcbCallCodes={wcbCallCodes}
                        changeSelectedCallCode={changeSelectedCallCode}
                    />
                </div>
                <input
                    name="wcb-phone"
                    autoCorrect="off"
                    autoComplete="off"
                    type="tel"
                    id="wcb-phone"
                    className="if input-field"
                    aria-labelledby="wcb-labelphone"
                    value={mobile}
                    onChange={handleChange}
                />
            </div>
            {mobileErrorMessage && (
                <span id="wcb-phone-error" className="errorMessage">
                    {mobileErrorMessage}
                </span>
            )}
        </div>
    );
};

export default WcbCallContainer;
